export default __webpack_public_path__ + "static/media/geshdologoWhite.457d7bdd.png";